import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

// Wraps Tom Select (https://tom-select.js.org) for the design system's
// select dropdown component. Supports single-select, multi-select (with
// remove buttons) and free-form tag creation.
//
// Usage:
//   %select{ data: { controller: 'select', select_placeholder_value: 'Pick…' } }
//   %select{ multiple: true, data: { controller: 'select' } }
//   %select{ data: { controller: 'select', select_create_value: true } }
export default class extends Controller {
  static values = {
    create: Boolean,
    multiple: Boolean,
    placeholder: String,
    noSearch: Boolean
  }

  connect() {
    const multiple = this.multipleValue || this.element.multiple

    this.instance = new TomSelect(this.element, {
      create: this.createValue,
      maxItems: multiple ? null : 1,
      placeholder: this.placeholderValue,
      plugins: multiple ? ['remove_button'] : []
    })

    if (this.noSearchValue) {
      this.instance.wrapper.classList.add('no-search')
    }
  }

  disconnect() {
    this.instance?.destroy()
  }
}
